import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { MoneyFlowLottie } from './MoneyFlowLottie';

// This component exists to apply absolute styling to the Lottie so that we can use it as a background image with the other
// items in the layout placed on top of it.
// If we end up needing to re-use this pattern we should pull this out into a more generic component or layout.
export const MoneyFlowBackground = ({ resource }) => {
  const isMobile = useMobileLayout();
  return !isMobile ? resource.withRelationship(fr.relationships.lottie.name,
    (rel) => (
      <MoneyFlowLottie src={rel.link('related').url()} isAbsolute />
    ),
    () => null) : null;
};

MoneyFlowBackground.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
